import { Injectable } from '@angular/core';
import * as echarts from 'echarts/core';

@Injectable({
  providedIn: 'root',
})
export class EchartsSvgExporterService {
  downloadSvgGraphAsPng(
    chart: echarts.ECharts,
    chartContainer: HTMLDivElement,
    filename: string = 'chart.png',
    chartTitle: string | null = null
  ) {
    let originalTitle: string | undefined;
    if (chartTitle) {
      originalTitle = (chart.getOption()['title'] as any)?.text as string | undefined;
      chart.setOption({
        title: {
          text: chartTitle,
        },
      });
    }

    this.svgToPng(chart, chartContainer, filename);

    chart.setOption({
      title: {
        text: originalTitle ?? '',
      },
    });
  }

  private svgToPng(chart: echarts.ECharts, chartContainer: HTMLDivElement, filename: string = 'chart.png') {
    const width = chartContainer.offsetWidth;
    const height = chartContainer.offsetHeight;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      console.error('Canvas context is null');
      return;
    }
    canvas.width = width;
    canvas.height = height;

    const img = new Image();
    img.onload = () => {
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);

      const pngDataUrl = canvas.toDataURL('image/png');
      this.downloadPng(pngDataUrl, filename);
    };

    img.onerror = function (error) {
      console.error('Error loading chart image:', error);
    };

    img.src = chart.getDataURL({ type: 'png' });
  }

  private downloadPng(dataUrl: string, filename: string) {
    const link = document.createElement('a');
    link.download = filename;
    link.href = dataUrl;
    link.click();
  }
}
